import { Box } from "@mui/material";

const CaltexInnerCard = (props) => {
    return (
        <Box sx={{ padding: "1.5rem 1rem", display: "flex", flexDirection: "column", gap: ".5rem" }}>
            {props.children}
        </Box>
    );
};

export default CaltexInnerCard;
